/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BedNoteCreatedByUser } from './BedNoteCreatedByUser';
import {
    BedNoteCreatedByUserFromJSON,
    BedNoteCreatedByUserFromJSONTyped,
    BedNoteCreatedByUserToJSON,
} from './BedNoteCreatedByUser';
import type { BedPccMapping } from './BedPccMapping';
import {
    BedPccMappingFromJSON,
    BedPccMappingFromJSONTyped,
    BedPccMappingToJSON,
} from './BedPccMapping';
import type { BedType } from './BedType';
import {
    BedTypeFromJSON,
    BedTypeFromJSONTyped,
    BedTypeToJSON,
} from './BedType';
import type { Occupancy } from './Occupancy';
import {
    OccupancyFromJSON,
    OccupancyFromJSONTyped,
    OccupancyToJSON,
} from './Occupancy';
import type { ScreenerBedRoom } from './ScreenerBedRoom';
import {
    ScreenerBedRoomFromJSON,
    ScreenerBedRoomFromJSONTyped,
    ScreenerBedRoomToJSON,
} from './ScreenerBedRoom';

/**
 * 
 * @export
 * @interface Bed
 */
export interface Bed {
    /**
     * 
     * @type {string}
     * @memberof Bed
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Bed
     */
    facility_id: string;
    /**
     * 
     * @type {Array<BedType>}
     * @memberof Bed
     */
    bed_types: Array<BedType>;
    /**
     * 
     * @type {string}
     * @memberof Bed
     */
    name: string;
    /**
     * 
     * @type {Array<Occupancy>}
     * @memberof Bed
     */
    active_occupancy_list: Array<Occupancy>;
    /**
     * 
     * @type {string}
     * @memberof Bed
     */
    room_id?: string;
    /**
     * 
     * @type {ScreenerBedRoom}
     * @memberof Bed
     */
    room?: ScreenerBedRoom;
    /**
     * 
     * @type {string}
     * @memberof Bed
     */
    note?: string;
    /**
     * ID of the user who created the note
     * @type {string}
     * @memberof Bed
     */
    note_created_by_user_id?: string;
    /**
     * Timestamp when the note was created
     * @type {Date}
     * @memberof Bed
     */
    note_created_at?: Date;
    /**
     * 
     * @type {BedNoteCreatedByUser}
     * @memberof Bed
     */
    note_created_by_user?: BedNoteCreatedByUser;
    /**
     * 
     * @type {BedPccMapping}
     * @memberof Bed
     */
    pcc_mapping?: BedPccMapping;
}

/**
 * Check if a given object implements the Bed interface.
 */
export function instanceOfBed(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "bed_types" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "active_occupancy_list" in value;

    return isInstance;
}

export function BedFromJSON(json: any): Bed {
    return BedFromJSONTyped(json, false);
}

export function BedFromJSONTyped(json: any, ignoreDiscriminator: boolean): Bed {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'facility_id': json['facility_id'],
        'bed_types': ((json['bed_types'] as Array<any>).map(BedTypeFromJSON)),
        'name': json['name'],
        'active_occupancy_list': ((json['active_occupancy_list'] as Array<any>).map(OccupancyFromJSON)),
        'room_id': !exists(json, 'room_id') ? undefined : json['room_id'],
        'room': !exists(json, 'room') ? undefined : ScreenerBedRoomFromJSON(json['room']),
        'note': !exists(json, 'note') ? undefined : json['note'],
        'note_created_by_user_id': !exists(json, 'note_created_by_user_id') ? undefined : json['note_created_by_user_id'],
        'note_created_at': !exists(json, 'note_created_at') ? undefined : (new Date(json['note_created_at'])),
        'note_created_by_user': !exists(json, 'note_created_by_user') ? undefined : BedNoteCreatedByUserFromJSON(json['note_created_by_user']),
        'pcc_mapping': !exists(json, 'pcc_mapping') ? undefined : BedPccMappingFromJSON(json['pcc_mapping']),
    };
}

export function BedToJSON(value?: Bed | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'facility_id': value.facility_id,
        'bed_types': ((value.bed_types as Array<any>).map(BedTypeToJSON)),
        'name': value.name,
        'active_occupancy_list': ((value.active_occupancy_list as Array<any>).map(OccupancyToJSON)),
        'room_id': value.room_id,
        'room': ScreenerBedRoomToJSON(value.room),
        'note': value.note,
        'note_created_by_user_id': value.note_created_by_user_id,
        'note_created_at': value.note_created_at === undefined ? undefined : (value.note_created_at.toISOString()),
        'note_created_by_user': BedNoteCreatedByUserToJSON(value.note_created_by_user),
        'pcc_mapping': BedPccMappingToJSON(value.pcc_mapping),
    };
}

